// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TJ69T0gm8D5GkA {
  justify-content: flex-start;
  width: 100%;
  border-radius: 8px;
  background-color: var(--ds-background-neutral-subtle, #00000000);
  color: var(--ds-text, #172b4d);
  font-weight: 400;
}
.TJ69T0gm8D5GkA:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, #091e420f);
}
.TJ69T0gm8D5GkA .S1YMKJFPn9WNGk {
  margin-left: 3px;
}
.tlkhw6C_OG8i32 > span {
  flex-shrink: 0;
  margin-right: 11px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardMenuButton": `TJ69T0gm8D5GkA`,
	"buttonContents": `S1YMKJFPn9WNGk`,
	"buttonIcon": `tlkhw6C_OG8i32`
};
export default ___CSS_LOADER_EXPORT___;
